import React, { ReactElement } from 'react';
import { makeStyles } from '@mui/styles';
import { InputLabel, MenuItem, FormControl, Select, SelectProps } from '@mui/material';
import StyledBaseInput from './StyledBaseInput';
import { remCalc } from 'util/style-util';

export interface DropDownOptions {
  label: string | ReactElement;
  value: any;
}

export type DropdownProps = Omit<SelectProps, 'onChange' | 'error' | 'label'> & {
  options: Array<DropDownOptions>;
  label?: string | ReactElement;
  onChange: (name, value) => void;
  error?: string | undefined;
  selectClass?: any;
  labelStyle?: React.CSSProperties;
};

const useStyles = makeStyles(() => ({
  dropdown: {
    height: '70px',
    borderRadius: '8px',
    fontWeight: '300 !important',
    width: '320px',
    '&.MuiSelect-select': {
      backgroundColor: '#FFFFFF',
      '&:focus': {
        backgroundColor: '#FFFFFF'
      }
    }
  }
}));

const Dropdown: React.FC<DropdownProps> = ({
  id,
  label,
  onChange,
  value,
  options,
  selectClass,
  labelStyle,
  ...rest
}) => {
  const classes = useStyles();

  const handleChange = (e: React.ChangeEvent<{ name?: string; value?: unknown }>) => {
    const { name, value } = e.target;
    return onChange(name, value);
  };

  return (
    <FormControl className={classes.dropdown} sx={{ margin: 'auto' }} variant="standard">
      {label && (
        <InputLabel
          id={`${id}-select-label`}
          sx={{ fontSize: '15px', fontWeight: 400, marginLeft: remCalc(3), ...labelStyle }}
        >
          {label}
        </InputLabel>
      )}

      <Select
        id={`${id}-select`}
        labelId={`${id}-select-label`}
        className={selectClass}
        value={value}
        onChange={handleChange as any}
        input={<StyledBaseInput />}
        {...(rest as any)}
      >
        {options.map(
          (option, idx): ReactElement => (
            <MenuItem key={`${idx}-dropdown-${id}-item`} value={option.value}>
              {option.label}
            </MenuItem>
          )
        )}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
